export function Ico84Mail() {
  return (
    <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="42" cy="42" r="42" fill="#ECF6FF" />
      <path
        d="M20.4204 31.7603L30.5831 42.5093C30.676 42.6082 30.6735 42.7665 30.5733 42.8604L20.4106 52.4423C20.2542 52.5882 20 52.4769 20 52.2618V31.9309C20 31.7083 20.2689 31.5995 20.4204 31.7603Z"
        fill="#0087E0"
      />
      <path
        d="M63.9954 31.9309V52.2618C63.9954 52.4769 63.7412 52.5882 63.5848 52.4423L53.4221 42.8604C53.3219 42.7665 53.317 42.6082 53.4123 42.5093L63.575 31.7603C63.7265 31.5995 63.9954 31.7083 63.9954 31.9309Z"
        fill="#0087E0"
      />
      <path
        d="M63.8976 26.7492C63.7045 26.2943 63.2621 26 62.7733 26H21.223C20.7341 26 20.2918 26.2943 20.0987 26.7492C19.9056 27.2042 20.0009 27.7309 20.3406 28.0895L41.1158 50.0747C41.3455 50.3195 41.6657 50.4555 41.9981 50.4555C42.3305 50.4555 42.6507 50.317 42.8804 50.0747L63.6556 28.0895C63.9953 27.7309 64.0906 27.2042 63.8976 26.7492Z"
        fill="#0087E0"
      />
      <path
        d="M63.9239 57.2073C63.7284 57.6771 63.2884 57.9986 62.7752 57.9986H21.2249C20.7116 57.9986 20.2716 57.6771 20.0761 57.2073C19.905 56.7375 20.0272 56.1935 20.3938 55.8473L32.4434 44.4727L39.3603 51.792C40.0447 52.5091 40.9979 52.9295 42 52.9295C43.0021 52.9295 43.9553 52.5091 44.6397 51.792L51.5566 44.4727L63.6062 55.8473C63.9728 56.1935 64.095 56.7375 63.9239 57.2073Z"
        fill="#0087E0"
      />
    </svg>
  );
}
